import $ from 'domtastic'
import B, { getUtils, getRefs } from '@js/components/_common/_Base'

import { autoScrollTo, getPagePosition } from '@utils/utils'

import YouTubeIframe from '@utils/YouTubeIframe'
import Woosh from '@utils/Woosh'


import Slider from '@blocks/Slider'
import Dropdown from '@blocks/Dropdown'
import Wall from '@blocks/Wall'
import Ribbon from '@blocks/Ribbon'
import FloatingTabs from '@blocks/FloatingTabs'
import Quincux from '@blocks/Quincux'
import FormHelper from '@blocks/FormHelper'
import Filters from '@blocks/Filters'
import TrainingFilters from '@blocks/TrainingFilters'
import TagZone from '@blocks/TagZone'
import FloatingRibbons from '@blocks/FloatingRibbons'




const compsMap = {
    Slider,
    Ribbon,
    Dropdown,
    Wall,
    FloatingTabs,
    Quincux,
    FormHelper,
    Filters,
    TrainingFilters,
    TagZone,
    FloatingRibbons,
}




/* VIEW: BASEVIEW
---------------------------------------------------------------------------------------------------- */

export default class BaseView extends B {

    constructor(props) {
        super(props.namespace)

        this.props     = props
        this.namespace = (props && props.namespace) ? props.namespace : 'base'
        this.view      = document.body.getAttribute('data-v')
        this.comps     = {}

        this.parser = new DOMParser()

        this.baseResizeHandler = () => { this.onResize() }


        // @TODO: Remove if using Barba.
        this.beforeEnter({
            next: {
                container: document.querySelector('.view'),
                html: document.documentElement.innerHTML,
            },
        })
    }


    bindBaseEvents() {
        this.on()
    }


    destroy() {
        if (!this.view) return

        this.initialized = false
        this.off()
    }


    on() {
        this.events.forEach((ev) => {
            const [target, name, callback] = ev

            $(target).on(name, callback)
        })
    }


    off() {
        this.events.forEach((ev) => {
            const [target, name, callback] = ev

            $(target).off(name, callback)
        })
    }




    /* Hooks
    --------------------------------------------------------- */

    afterOnce() {
        this.init(true)
    }


    beforeLeave() {
        //
    }


    afterLeave() {
        this.destroy()
    }


    beforeEnter({ next }) {
        const html = this.parser.parseFromString(next.html, 'text/html')

        this.$ctn = $(next.container)
        this.view = html.body.getAttribute('data-v')

        this.$utils = getUtils()
        this.$refs  = getRefs(document.body, this.view.charAt(0).toUpperCase() + this.view.slice(1))

        this.woosh  = new Woosh(this.$ctn)

        this.addListeners(
            [document, 'layoutChange', this.baseResizeHandler],
        )

        this.getAnchors()
        this.initYTiFrame()

        this.bindBaseEvents()
        setTimeout(() => { this.init() }, 0)
    }


    afterEnter() {
        this.init(true)
    }




    /* Init
    --------------------------------------------------------- */

    init() {
        this.initialized = true

        this.initComps('data-component', true)
    }


    initComps(sel = 'data-component', initWoosh) {
        if (initWoosh) {
            this.woosh.init()
        }

        $(`[${sel}]`).each((el, i) => {
            const $el = $(el)

            const compName  = $el.attr('data-component').replace(/-|\s/g, '')
            const compsList = compName.split(',')

            $el.removeAttr('data-component')

            compsList.forEach((c) => {
                if (compsMap[c]) {
                    if (!this.comps[c]) {
                        this.comps[c] = []
                    }

                    this.comps[c].push(new compsMap[c]($el, this.namespace, this.view, this, i))
                } else {
                    console.warn(`Component [${c}] not registered in BaseView.`)
                }
            })
        })
    }


    initYTiFrame() {
        this.ytAPI = new YouTubeIframe(this.$ctn, this.namespace)
    }


    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        this.woosh.resize()
    }

    /* eslint-disable class-methods-use-this */
    onAnchorClick(e) {
        e.preventDefault()

        scrollToID(e.target.getAttribute('href') || e.target.closest('[href]').getAttribute('href'))
    }
    /* eslint-enable class-methods-use-this */



    /* Values
    --------------------------------------------------------- */

    getAnchors() {
        const $anchors = this.$ctn.find('.js-anchorLink')

        $anchors.forEach(($a) => {
            this.addListener($a, 'click', (e) => { this.onAnchorClick(e) })
        })
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */

const scrollToID = (id) => {
    const $target = document.querySelector(id)

    if ($target) {
        autoScrollTo(getPagePosition($target).y)
    }
}


